import { isEmpty as _isEmpty } from '@lodash';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IMatchResultDto from '@core/mappers/offer/dtos/IMatchResultDto';
import MatchResult, { Score } from '@core/models/offer/MatchResult';
import IMetaDataDto from './dtos/IMetaDataDto';

interface MapperResult {
    score: MatchResult[];
    isGoingToNextRound: null | 1 | 2;
    winner: null | 1 | 2;
    finalScore: null | Score; // final score is for football number of goals per team, tennis sets per team
    totalPoints: null | number;
    result: null | Score; // total point when point are separated into groups. e.g. tennis, number of gems
}

interface Input {
    matchResults?: IMatchResultDto[];
    metaData?: IMetaDataDto;
}
export default class MatchResultMapper extends AbstractMapper<Input, MapperResult> {

    parseValue(value: string): Score {
        const score = value.split(':').map(x => x.replace(/\D/g, ''));
        const team1Score = parseInt(score[0], 10);
        const team2Score = parseInt(score[1], 10);
        return {
            team1Score: Number.isNaN(team1Score) ? '-' : team1Score,
            team2Score: Number.isNaN(team2Score) ? '-' : team2Score,
        };
    }

    createTargetObject({ matchResults, metaData }: Input): MapperResult {
        const mapperResult: MapperResult = {
            score: [],
            isGoingToNextRound: null,
            winner: null,
            finalScore: null,
            totalPoints: null,
            result: null,
        };
        if (matchResults) {
            matchResults.forEach((result, index) => {
                let i;

                if ((i = `${result.v}`.search('')) !== -1) {
                    if (i === 0) {
                        mapperResult.isGoingToNextRound = 1; // first team is going to next round
                    } else {
                        mapperResult.isGoingToNextRound = 2; // second team is going to next round
                    }
                }
                if (index === matchResults.length - 1) {
                    mapperResult.score.push({
                        name: result.n,
                        value: null,
                    });
                    return;
                }
                mapperResult.score.push({
                    name: result.n,
                    value: this.parseValue(result.v as string),
                });
            });
            const firstElement = matchResults[0];

            if (firstElement) {
                mapperResult.result = this.parseValue(firstElement.v as string);
            }

            const lastElement = matchResults[matchResults.length - 1];
            if (lastElement) {
                // tslint:disable-next-line triple-equals
                if (lastElement.v == '1' || lastElement.v == '2') {
                    mapperResult.winner = matchResults[matchResults.length - 1].v as 1 | 2;
                } else if (lastElement.v && typeof lastElement.v === 'string') {
                    mapperResult.finalScore = this.parseValue(lastElement.v as string);
                } else if (typeof lastElement.v === 'number') {
                    mapperResult.totalPoints = lastElement.v;
                }
            }
        }

        const isEmpty = !matchResults
            || mapperResult.score.every((score) => (!score.value || score.value.team1Score === '-'));
        // if match results are empty
        if (isEmpty && metaData) {
            const {
                t1Scr: team1Score,
                t2Scr: team2Score
            } = metaData;

            if (team1Score !== undefined && team2Score !== undefined && mapperResult.score[0]) {
                mapperResult.score[0].value = {
                    team1Score,
                    team2Score,
                };
                mapperResult.result = {
                    team1Score,
                    team2Score,
                };
            }
        }
        return mapperResult;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/MatchResultMapper.ts